import type { CommentActionType, CommentData } from '@/types';

import type { TPostCommentFormElement } from '../../postCommentFormElement';
import { ComponentContext } from './ComponentContext';
export interface ComponentContextType {
  canReply: boolean;
  showActions: boolean;
  isLive: boolean;
  isSubmitting: boolean;
  replyNode?: TPostCommentFormElement;
  onLike?: (formData: FormData) => Promise<boolean>;
  onCommentChange?: (comment: CommentData['content']) => void;
  onClickReply?: (replyingToCommentId: string | null) => void;
  onClickAction?: (action: CommentActionType, comment: CommentData) => void;
  replyingToCommentId?: string | null;
  avatarUrl?: string;
  isLoggedInAsAdmin?: boolean;
  isVisitorLoggedIn?: boolean;
  onClickLogin?: () => void;
  onClickSubscribe?: () => void;
  translations?: Record<string, string>;
  commenterId?: number | string;
  // Edit comment props
  editingCommentId?: string | null;
  onEditComment?: (commentId: string, newContent: string) => void;
  onCancelEdit?: () => void;
  isEditSubmitting?: boolean;
  // Avatar upload props
  onAvatarUpload?: (file: File) => void;
  isAvatarUploading?: boolean;
  canUploadAvatar?: boolean;
}

interface ComponentProviderProps {
  children: React.ReactNode;
  canReply: boolean;
  showActions: boolean;
  isLive: boolean;
  isSubmitting: boolean;
  replyNode?: TPostCommentFormElement;
  onLike?: (formData: FormData) => Promise<boolean>;
  onCommentChange?: (comment: CommentData['content']) => void;
  onClickReply?: (replyingToCommentId: string | null) => void;
  onClickAction?: (action: CommentActionType, comment: CommentData) => void;
  replyingToCommentId?: string | null;
  avatarUrl?: string;
  isLoggedInAsAdmin?: boolean;
  isVisitorLoggedIn?: boolean;
  onClickLogin?: () => void;
  onClickSubscribe?: () => void;
  translations?: Record<string, string>;
  commenterId?: number | string;
  // Edit comment props
  editingCommentId?: string | null;
  onEditComment?: (commentId: string, newContent: string) => void;
  onCancelEdit?: () => void;
  isEditSubmitting?: boolean;
  // Avatar upload props
  onAvatarUpload?: (file: File) => void;
  isAvatarUploading?: boolean;
  canUploadAvatar?: boolean;
}

export const ComponentProvider: React.FC<ComponentProviderProps> = ({
  children,
  onLike,
  onCommentChange,
  canReply,
  showActions,
  isLive,
  replyNode,
  isSubmitting,
  onClickReply,
  replyingToCommentId,
  onClickAction,
  avatarUrl,
  isLoggedInAsAdmin,
  isVisitorLoggedIn,
  onClickLogin,
  onClickSubscribe,
  translations,
  commenterId,
  editingCommentId,
  onEditComment,
  onCancelEdit,
  isEditSubmitting,
  onAvatarUpload,
  isAvatarUploading,
  canUploadAvatar,
}) => {
  return (
    <ComponentContext.Provider
      value={{
        onLike,
        onCommentChange,
        canReply,
        showActions,
        isLive,
        replyNode,
        isSubmitting,
        onClickReply,
        replyingToCommentId,
        onClickAction,
        avatarUrl,
        isLoggedInAsAdmin,
        isVisitorLoggedIn,
        onClickLogin,
        onClickSubscribe,
        translations,
        commenterId,
        editingCommentId,
        onEditComment,
        onCancelEdit,
        isEditSubmitting,
        onAvatarUpload,
        isAvatarUploading,
        canUploadAvatar,
      }}
    >
      {children}
    </ComponentContext.Provider>
  );
};
